<style>
  .footer-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .footer-content:not(:first-child) {
    margin-top: 40px;
  }

  .footer-links {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    margin-bottom: 40px;
  }

  .footer-subscribe {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .footer-input {
    padding: 4px 16px;
    margin-bottom: 16px;

    border: none;

    border-radius: 7px;
    color: #2744f7;

    font-family: 'Averta Std';
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 35px;
  }

  .footer-copyright {
    min-width: 100%;
    margin: 0;

    color: #091135;

    font-family: 'Averta Std';
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 35px;
  }

  .footer-copyright {
    flex: 1;
  }

  .footer-social {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .footer-social svg {
    width: auto;
    height: 40px;
    margin-left: 16px;
  }

  @media (min-width: 1280px) {
    .footer-links {
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 0;
    }

    .footer-subscribe {
      flex: 2;
      justify-content: flex-end;
    }

    .footer-input {
      margin-right: 16px;
      margin-bottom: 0;
    }
  }
</style>

<script>
  import Link from '../Atoms/Link.svelte';
  import Button from '../Atoms/Button.svelte';

  const SUBSCRIBE_URL = "https://api.universalprotocol.io/v0/newsletters/subscribe"

  const onSubmit = () => {
    event.preventDefault();

    fetch(SUBSCRIBE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({email: event.target.elements.email.value})
    })
    .then(() => {
      window.location.replace("https://universalprotocol.io/?event=newsletter_success")
    })
  }
</script>

<div class="footer-content">
  <div class="footer-links">
    <Link href="https://www.universalprotocol.io/s/whitepaper.pdf">Whitepaper</Link>
    <Link href="https://universalprotocol.io/static/documents/one-pager.pdf?version=4.0">One Pager</Link>
    <Link href="mailto:support@universalprotocol.io">Contact Us</Link>
  </div>
  <form class="footer-subscribe" action={SUBSCRIBE_URL} method="POST" on:submit={onSubmit}>
    <input
      id="subscribe"
      class="footer-input"
      placeholder="you@email.com"
      type="email"
      name="email"
      label="email"
    />
    <Button type="submit" alternate>Subscribe</Button>
  </form>
</div>

<div class="footer-content">
  <p class="footer-copyright">
    © 2018 Universal Protocol Token. All Rights Reserved
  </p>
  <div class="footer-social">
    <Link alternate href="https://www.reddit.com/r/universalprotocol/">
      <svg viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="38.4545" height="38" rx="19" fill="white" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.7338 16.7902C26.9744 16.7902 27.9838 17.7937 27.9838 19.0271C27.9838 19.6261 27.747 20.1884 27.3267 20.6062C27.5774 21.1412 27.7043 21.6976 27.7043 22.2638C27.7043 23.8007 26.7789 25.2351 25.0983 26.3028C23.4625 27.3422 21.2938 27.9147 18.9919 27.9147C16.6901 27.9147 14.5213 27.3422 12.8855 26.3028C11.2049 25.2351 10.2794 23.8007 10.2794 22.2638C10.2794 21.6975 10.4064 21.1411 10.6571 20.6062C10.2368 20.1885 10 19.6261 10 19.0271C10 17.7937 11.0093 16.7902 12.25 16.7902C12.9422 16.7902 13.579 17.0978 14.0037 17.6251C15.3774 17.0037 16.9732 16.6577 18.6552 16.6169L20.1791 11.8296C20.2792 11.515 20.604 11.328 20.9281 11.3978L24.11 12.0833C24.416 11.4436 25.0716 11 25.8302 11C26.8804 11 27.7348 11.8494 27.7348 12.8935C27.7348 13.9375 26.8804 14.7868 25.8302 14.7868C24.9436 14.7868 24.1969 14.1812 23.9857 13.3643L21.2281 12.7704L19.9935 16.6492C21.4304 16.7543 22.7888 17.0863 23.9802 17.6251C24.4048 17.0978 25.0416 16.7902 25.7338 16.7902ZM10.7714 19.0271C10.7714 19.3025 10.8458 19.5644 10.988 19.7938C11.5118 19.062 12.2517 18.4238 13.1917 17.8932C12.9287 17.6754 12.6 17.5571 12.25 17.5571C11.4347 17.5571 10.7714 18.2166 10.7714 19.0271ZM14.374 21.089C14.374 20.208 15.095 19.4912 15.9811 19.4912C16.8673 19.4912 17.5883 20.208 17.5883 21.089C17.5883 21.97 16.8673 22.6867 15.9811 22.6867C15.095 22.6867 14.374 21.97 14.374 21.089ZM18.9919 25.8374C20.399 25.8374 21.6623 25.4151 22.2888 24.7353C22.4048 24.6094 22.4646 24.4461 22.457 24.2757C22.4496 24.1051 22.3758 23.9476 22.2491 23.8323C22.1303 23.7241 21.9761 23.6644 21.8149 23.6644C21.635 23.6644 21.4623 23.74 21.3408 23.8717C20.9678 24.2765 20.002 24.5592 18.9919 24.5592C17.9818 24.5592 17.016 24.2765 16.643 23.8717C16.5215 23.74 16.3488 23.6644 16.169 23.6644C16.0078 23.6644 15.8537 23.7241 15.7348 23.8323C15.6082 23.9476 15.5343 24.1051 15.5268 24.2757C15.5194 24.4461 15.579 24.6094 15.6951 24.7353C16.3215 25.4151 17.5848 25.8374 18.9919 25.8374ZM22.0027 22.6867C21.1165 22.6867 20.3955 21.97 20.3955 21.089C20.3955 20.208 21.1165 19.4912 22.0027 19.4912C22.8888 19.4912 23.6098 20.208 23.6098 21.089C23.6098 21.97 22.8888 22.6867 22.0027 22.6867ZM24.7921 17.8932C25.7321 18.4238 26.4721 19.062 26.9958 19.7938C27.138 19.5644 27.2124 19.3025 27.2124 19.0271C27.2124 18.2166 26.5491 17.5571 25.7338 17.5571C25.3838 17.5571 25.0551 17.6754 24.7921 17.8932Z"
          fill="#091135"
        />
      </svg>
    </Link>

    <Link alternate href="https://twitter.com/UPPlatform">
      <svg viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="38.45" height="38" rx="19" fill="#fff" />
        <path
          d="M28.4 13.72c-.66.29-1.2.3-1.79.02.75-.45.79-.76 1.06-1.6-.7.4-1.48.71-2.31.87a3.66 3.66 0 00-6.3 2.46c0 .28.03.56.1.82a10.37 10.37 0 01-7.51-3.76 3.55 3.55 0 001.13 4.8 3.66 3.66 0 01-1.65-.44v.04c0 1.75 1.25 3.2 2.92 3.53a3.7 3.7 0 01-1.65.06 3.64 3.64 0 003.4 2.5 7.38 7.38 0 01-5.39 1.49A10.4 10.4 0 0016 26.12a10.22 10.22 0 0010.34-10.7c.71-.5 1.57-.98 2.06-1.7z"
          fill="#091135"
        />
      </svg>
    </Link>

    <Link alternate href="https://t.me/universalprotocolplatform">
      <svg viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="38.4545" height="38" rx="19" fill="white" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.9646 12.3228C27.8998 12.1327 27.823 12.0807 27.7028 12.0346C27.4397 11.9338 26.9943 12.0852 26.9943 12.0852C26.9943 12.0852 11.2229 17.8118 10.3219 18.446C10.1278 18.5826 10.063 18.6617 10.0309 18.7549C9.87501 19.2065 10.3602 19.4055 10.3602 19.4055L14.4251 20.7436C14.4251 20.7436 14.5768 20.7658 14.6309 20.7312C15.5555 20.1409 23.9346 14.7961 24.4181 14.6164C24.4943 14.5936 24.5506 14.6198 24.5356 14.6729C24.3421 15.3587 17.0646 21.8934 17.0646 21.8934C17.0646 21.8934 17.0368 21.9277 17.0193 21.9692L17.0097 21.9634L16.6304 26.0365C16.6304 26.0365 16.4715 27.2843 17.7067 26.0365C18.5783 25.1561 19.4215 24.4196 19.8436 24.0611C21.2413 25.0359 22.7457 26.1142 23.3946 26.6782C23.7207 26.9616 23.9934 27.0076 24.218 26.9991C24.8342 26.9757 25.0062 26.2919 25.0062 26.2919C25.0062 26.2919 27.8801 14.6074 27.9763 13.0418C27.9856 12.8884 27.9986 12.7907 27.9999 12.6853C28.0016 12.539 27.988 12.392 27.9646 12.3228Z"
          fill="#091135"
        />
      </svg>
    </Link>

    <Link alternate href="https://www.facebook.com/UPPlatform/">
      <svg viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="38.4545" height="38" rx="19" fill="white" />
        <path
          d="M24.0342 15.5742H20.6896V14.1294C20.6896 13.4499 21.1551 13.2914 21.4827 13.2914C21.8102 13.2914 23.8242 13.2914 23.8242 13.2914V10.3016L21.2329 10.2917C18.1556 10.2917 17.5726 12.52 17.5726 13.9474V15.5735H15.2217V18.6072H17.5726C17.5726 22.5602 17.5726 27.7084 17.5726 27.7084H20.6896C20.6896 27.7084 20.6896 22.5131 20.6896 18.6072H23.7074L24.0342 15.5742Z"
          fill="#091135"
        />
      </svg>
    </Link>
  </div>
</div>
